import React from 'react';
import './ShimmerButton.css';

const ShimmerButton = ({ children, onClick, className = '' }) => {
  return (
    <button 
      className={`shimmer-button ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ShimmerButton;
